import ChangePassword from "pages/ChangePassword/changePassword";
import ListDataRegistryDelegate from "pages/DataFormatInvoice/Registry-delegate/ListData";
import ListDataRegistryInvoice from "pages/DataFormatInvoice/Registry-invoice/ListData";
import ListDataRequestInvoiceCode from "pages/DataFormatInvoice/Request-invoice-code/ListData";
import CreateWareHouses from "pages/DeliveryBill/CreateWareHouses";
import ListInvoiceWareHouses from "pages/DeliveryBill/ListInvoiceWareHouses";
import CreateErrorInvoice from "pages/Error-invoice/CreateErrorInvoice";
import ListDataErrorInvoice from "pages/Error-invoice/ListData";
import ListDataInvoiceInvoiceErrors from "pages/InvoiceInvoiceErrors/ListData";
import CreateStatement from "pages/InvoiceStatement/CreateStatement";
import StatementList from "pages/InvoiceStatement/StatementList";
// import CreateUser from "pages/UserManagement/CreateUser";
// import ListUser from "pages/UserManagement/ListUser";
import ListExportInvoice from "pages/ExportInvoice/ListExportInvoice";
import ListExportInvoicePos from "pages/ExportInvoice/ListExportInvoicePos";
import CreateBusinessUnit from "pages/GeneralInfo/BusinessUnitBK/Create";
import BusinessUnitDetail from "pages/GeneralInfo/BusinessUnitBK/Detail";
import ListBusinessUnit from "pages/GeneralInfo/BusinessUnitBK/List";
import CreateCurrencyManager from "pages/GeneralInfo/Currency/Create";
import ListCurrencyManager from "pages/GeneralInfo/Currency/List";
import ListCustomer from "pages/GeneralInfo/Customer/ListData";
import ListInvoiceSymbol from "pages/GeneralInfo/InvoiceSymbol/ListInvoiceSymbol";
import CreatePaymentMethodManager from "pages/GeneralInfo/PaymentMethod/Create";
import ListPaymentMethodManager from "pages/GeneralInfo/PaymentMethod/List";
import ListProduct from "pages/GeneralInfo/Product/ListData";
import ListSignMethod from "pages/GeneralInfo/SignMethod/ListData";
import ListUser from "pages/GeneralInfo/User/ListData";
import ListVATManager from "pages/GeneralInfo/VAT/List";
import ListDataCampaign from "pages/InvoiceCampaign/ListData";
import InvoiceTemplateEditor from "pages/InvoiceTemplates/InvoiceTemplateEditor";
import InvoiceTemplateSelection from "pages/InvoiceTemplates/InvoiceTemplateSelection";
import CreateInvoiceTotal from "pages/InvoiceTotal/CreateData";
import CreateInvoice from "pages/IssueInvoice/CreateInvoice";
import DetailInvoicePage from "pages/IssueInvoice/DetailInvoicePage";
import ListErrorTCT from "pages/IssueInvoice/ErrorTCT/ListErrorTCT";
import ListAdjust from "pages/IssueInvoice/ListAdjust";
import ListAdjustOld from "pages/IssueInvoice/ListAdjustOld";
import ListAllInvoice from "pages/IssueInvoice/ListAllInvoice";
import ListCancel from "pages/IssueInvoice/ListCancel";
import ListNewInvoice from "pages/IssueInvoice/ListNewInvoice";

import ListReleaseInvoice from "pages/IssueInvoice/ListReleaseInvoice";
import ListReplace from "pages/IssueInvoice/ListReplace";
import ListReplaceOld from "pages/IssueInvoice/ListReplaceOld";
import ListWaitReleaseInvoice from "pages/IssueInvoice/ListWaitReleaseInvoice";
import ListInvoiceTickets from "pages/IssueInvoiceAnother/ListInvoiceTickets";
import ListDataNoticeFromTCT from "pages/NoticeFromTCT/ListData";
import CreateNotification from "pages/NotificationManagement/CreateNotification";
import ListNotification from "pages/NotificationManagement/ListNotification";
import CreateReportInvoice from "pages/ReportInvoice/CreateData";
import ListReportInvoice from "pages/ReportInvoice/ListData";
import CreateReportInvoiceError from "pages/ReportInvoiceError/CreateData";
import ListReportInvoiceError from "pages/ReportInvoiceError/ListData";
import CreateReportInvoiceTotal from "pages/ReportInvoiceTotal/CreateData";
import ListReportInvoiceTotal from "pages/ReportInvoiceTotal/ListData";
import CreateReportInvoiceUse from "pages/ReportInvoiceUse/CreateData";
import ListReportInvoiceUse from "pages/ReportInvoiceUse/ListData";

import CreateReportInvoiceTransfer from "pages/ReportInvoiceTransfer/CreateData";
import ListReportInvoiceTransfer from "pages/ReportInvoiceTransfer/ListData";

import CreateReportTaxDeductUse from "pages/ReportTaxDeductUse/CreateData";
import ListReportTaxDeductUse from "pages/ReportTaxDeductUse/ListData";

import CreateReportTaxDeductTransfer from "pages/ReportTaxDeductTransfer/CreateData";
import ListReportTaxDeductTransfer from "pages/ReportTaxDeductTransfer/ListData";

import CreateReportInvoiceRejectedInday from "pages/ReportInvoiceRejectedInday/CreateData";
import ListReportInvoiceRejectedInday from "pages/ReportInvoiceRejectedInday/ListData";

import CreateReportZipFile from "pages/ReportZipFile/CreateData";
import ListReportZipFile from "pages/ReportZipFile/ListData";

import CreateData from "pages/SummaryInvoiceData/CreateData";
import ListData from "pages/SummaryInvoiceData/ListData";
import CreateWareHousesAgency from "pages/WarehouseAgency/CreateWareHousesAgency";
import ListInvoiceWareHousesAgency from "pages/WarehouseAgency/ListInvoiceWareHousesAgency";
import React from "react";
import { Redirect } from "react-router-dom";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
// Profile
import UserProfile from "../pages/Authentication/user-profile";
import BusinessEmailTemplateDetails from "../pages/BusinessEmailTemplates/BusinessEmailTemplateDetails";
import BusinessEmailTemplateList from "../pages/BusinessEmailTemplates/BusinessEmailTemplateList";
// Dashboard
import Dashboard from "../pages/Dashboard/index";
import ListInvoiceTemplates from "../pages/InvoiceTemplates/ListInvoiceTemplates";
// Portal
import ListExportInvoiceWareHouses from "pages/ExportInvoice/ListExportInvoiceWareHouses";
import ListExportInvoiceWareHousesAgency from "pages/ExportInvoice/ListExportInvoiceWareHousesAgency";
import DetailInvoicePosPage from "pages/InvoicePos/DetailInvoicePosPage";
import ListAllInvoicePos from "pages/InvoicePos/ListAllInvoicePos";
import ListCancelInvoicePos from "pages/InvoicePos/ListCancelInvoicePos";
import ListNewInvoicePos from "pages/InvoicePos/ListNewInvoicePos";
import ListReleaseInvoicePos from "pages/InvoicePos/ListReleaseInvoicePos";
import ListTaxRefusedApprovalInvoicePos from "pages/InvoicePos/ListTaxRefusedApprovalInvoicePos";
import ListWaitReleaseInvoicePos from "pages/InvoicePos/ListWaitReleaseInvoicePos";
import ListPhaseInvoicePos from "pages/InvoicePos/Phase/ListPhaseInvoicePos";
import ListTaxDeduct from "pages/TaxDeduct/ListData";
import ListTaxDeductRegister from "pages/TaxDeductRegister/ListData";
import Portal from "../pages/Portal/index";
import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";

import CreateErrorTaxDeduct from "pages/Error-invoice/CreateErrorTaxDeduct";
import ListErrorTaxDeduct from "pages/Error-invoice/ListErrorTaxDeduct";
import ListExportTaxDeduct from "pages/ExportInvoice/ListExportTaxDeduct";
import ListBathImport from "pages/TaxDeduct/BathImport/ListBathImport";
import ListAdjustTaxDeduct from "pages/TaxDeduct/ListAdjust";
import ListReplaceTaxDeduct from "pages/TaxDeduct/ListReplace";

const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },
  // //profile
  { path: "/profile", component: UserProfile },

  // User management
  // { path: "/user-management/list", component: ListUser },
  // { path: "/user-management/create", component: CreateUser },

  // General info - Business Unit
  { path: "/business-unit-manager/list", component: ListBusinessUnit },
  { path: "/business-unit-manager/create", component: CreateBusinessUnit },

  // General info - VAT
  { path: "/vat-manager/list", component: ListVATManager },

  // General info - Currency
  { path: "/currency-manager/list", component: ListCurrencyManager },
  { path: "/currency-manager/create", component: CreateCurrencyManager },

  // General info - Payment method
  { path: "/payment-method-manager/list", component: ListPaymentMethodManager },
  {
    path: "/payment-method-manager/create",
    component: CreatePaymentMethodManager,
  },

  // General info - Invoice Symbol
  { path: "/invoice-symbol-manager/list", component: ListInvoiceSymbol },
  { path: "/product/list", component: ListProduct },
  { path: "/customer/list", component: ListCustomer },
  { path: "/user/list", component: ListUser },
  // Method
  { path: "/sign-method/list", component: ListSignMethod },
  // Notification management
  { path: "/notification-management/list", component: ListNotification },
  { path: "/notification-management/create", component: CreateNotification },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
  // Thông báo từ TCT
  { path: "/notice-from-TCT", component: ListDataNoticeFromTCT },
  // Lập bảng tổng hợp dữ liệu hóa đơn
  { path: "/report/create-invoice-cycles", component: CreateData },
  { path: "/report/list-invoice-cycles", component: ListData },
  // Lập bảng kê hóa đơn
  { path: "/report/create-report-invoice", component: CreateReportInvoice },
  { path: "/report/list-report-invoice", component: ListReportInvoice },
  // Lập bảng kê tình hình sử dụng hóa đơn
  {
    path: "/report/create-report-invoice-use",
    component: CreateReportInvoiceUse,
  },
  { path: "/report/list-report-invoice-use", component: ListReportInvoiceUse },
  // Báo cáo đối soát truyền nhận hóa đơn
  {
    path: "/report/create-report-invoice-transfer",
    component: CreateReportInvoiceTransfer,
  },
  {
    path: "/report/list-report-invoice-transfer",
    component: ListReportInvoiceTransfer,
  },
  // Báo cáo hóa đơn bị từ chối trong ngày
  {
    path: "/report/create-report-invoice-rejected-inday",
    component: CreateReportInvoiceRejectedInday,
  },
  {
    path: "/report/list-report-invoice-rejected-inday",
    component: ListReportInvoiceRejectedInday,
  },
  // Bảng kê tổng hợp PDF/ XML
  {
    path: "/report/create-zip-file",
    component: CreateReportZipFile,
  },
  { path: "/report/list-zip-file/:id?", component: ListReportZipFile },
  // Lập bảng kê hóa đơn tổng
  {
    path: "/report/create-report-invoice-total",
    component: CreateReportInvoiceTotal,
  },
  {
    path: "/report/list-report-invoice-total",
    component: ListReportInvoiceTotal,
  },
  // Lập Bảng tổng hợp thông báo gửi CQT
  {
    path: "/report/create-report-invoice-error",
    component: CreateReportInvoiceError,
  },
  {
    path: "/report/list-report-invoice-error",
    component: ListReportInvoiceError,
  },
  // Đăng ký/ Ủy quyền/ Đề nghị
  { path: "/data-format/registry-invoice", component: ListDataRegistryInvoice },
  {
    path: "/data-format/registry-delegate",
    component: ListDataRegistryDelegate,
  },
  {
    path: "/data-format/request-invoice-code",
    component: ListDataRequestInvoiceCode,
  },
  // Lập hóa đơn
  { path: "/invoice/create", component: CreateInvoice },
  { path: "/invoice/new", component: ListNewInvoice },
  { path: "/invoice/release", component: ListReleaseInvoice },
  { path: "/invoice/wait-release", component: ListWaitReleaseInvoice },
  { path: "/invoice/all", component: ListAllInvoice },
  { path: "/invoice/cancel", component: ListCancel },
  { path: "/invoice/replace", component: ListReplace },
  { path: "/invoice/adjust", component: ListAdjust },
  { path: "/invoice/report", component: ListExportInvoice },
  {
    path: "/invoice/:id",
    component: DetailInvoicePage,
  },
  // HĐ từ MTT
  // { path: "/invoice-pos/create", component: CreateInvoicePos },
  { path: "/invoice-pos/create", component: CreateInvoice },
  { path: "/invoice-pos/new", component: ListNewInvoicePos },
  { path: "/invoice-pos/release", component: ListReleaseInvoicePos },
  { path: "/invoice-pos/wait-release", component: ListWaitReleaseInvoicePos },

  { path: "/invoice-pos/cancel", component: ListCancelInvoicePos },
  {
    path: "/invoice-pos/tax-refused-approval",
    component: ListTaxRefusedApprovalInvoicePos,
  },
  { path: "/invoice-pos/replace", component: ListReplace },
  { path: "/invoice-pos/adjust", component: ListAdjust },

  { path: "/invoice-pos/all", component: ListAllInvoicePos },
  { path: "/invoice-pos/phase", component: ListPhaseInvoicePos },
  { path: "/invoice-pos/report", component: ListExportInvoicePos },
  {
    path: "/invoice-pos/:id",
    component: DetailInvoicePosPage,
  },
  // Dev-test
  { path: "/invoice/replace-dev", component: ListReplaceOld },
  { path: "/invoice/adjust-dev", component: ListAdjustOld },

  // Phát hành hóa đơn tem,vé
  {
    path: "/issue-invoice-tickets",
    component: ListInvoiceTickets,
  },
  // Thống báo hóa đơn sai sót
  {
    path: "/error-invoices",
    component: ListDataErrorInvoice,
  },
  // Hóa đơn sai sót
  {
    path: "/error-invoices/invoices",
    component: ListDataInvoiceInvoiceErrors,
  },
  {
    path: "/error-invoices/create",
    component: CreateErrorInvoice,
  },
  // Bảng kê hóa đơn thay thế / điều chỉnh
  {
    path: "/invoice-statements/create",
    component: CreateStatement,
  },
  {
    path: "/invoice-statements",
    component: StatementList,
  },
  // phiếu xuất kho kiêm vận chuyển nội bộ
  {
    path: "/invoice-warehouses/create",
    component: CreateWareHouses,
  },
  {
    path: "/invoice-warehouses",
    component: ListInvoiceWareHouses,
  },
  // phiếu xuất kho gửi bán đại lý
  {
    path: "/invoice-warehouses-agency/create",
    component: CreateWareHousesAgency,
  },
  {
    path: "/invoice-warehouses-agency",
    component: ListInvoiceWareHousesAgency,
  },
  //
  {
    path: "/invoice-warehouses/report",
    component: ListExportInvoiceWareHouses,
  },
  {
    path: "/invoice-warehouses-agency/report",
    component: ListExportInvoiceWareHousesAgency,
  },
  //
  { path: "/invoice-warehouses/report", component: ListExportInvoice },

  // Danh sách hóa đơn tổng
  { path: "/invoice-total", component: CreateInvoiceTotal },
  {
    path: "/invoice-templates",
    component: ListInvoiceTemplates,
  },
  {
    path: "/invoice-templates/create/select-template",
    component: InvoiceTemplateSelection,
  },
  {
    path: "/invoice-templates/create",
    component: InvoiceTemplateEditor,
  },
  {
    path: "/invoice-templates/:templateId",
    component: InvoiceTemplateEditor,
  },
  {
    path: "/business-unit-manager/list/create",
    component: BusinessUnitDetail,
  },
  {
    path: "/business-unit-manager/list/:businessId",
    component: BusinessUnitDetail,
  },
  {
    path: "/business-email-templates",
    component: BusinessEmailTemplateList,
  },
  {
    path: "/business-email-templates/:action",
    component: BusinessEmailTemplateDetails,
  },
  {
    path: "/business-email-templates/:action/:id",
    component: BusinessEmailTemplateDetails,
  },
  { path: "/change-password", component: ChangePassword, isNoneLayout: true },
  // Lập hóa đơn theo lô
  { path: "/invoice-campaign", component: ListDataCampaign },
  // Hóa đơn treo / lỗi truyền nhận
  { path: "/invoice-error-tct", component: ListErrorTCT },
  // Tờ khai đăng ký/thay đổi thông tin sử dụng chứng từ điện tử
  {
    path: "/tax-deduct/register",
    component: ListTaxDeductRegister,
  },
  {
    path: "/tax-deduct/list",
    component: ListTaxDeduct,
  },
  { path: "/tax-deduct/replace", component: ListReplaceTaxDeduct },
  { path: "/tax-deduct/adjust", component: ListAdjustTaxDeduct },
  // Tải lên theo đợt
  {
    path: "/tax-deduct/batch/:id?",
    component: ListBathImport,
  },
  // Chứng từ sai sót
  {
    path: "/error-tax-deducts",
    component: ListErrorTaxDeduct,
  },
  {
    path: "/error-tax-deducts/create",
    component: CreateErrorTaxDeduct,
  },
  { path: "/tax-deduct/report", component: ListExportTaxDeduct },
  {
    path: "/tax-deduct/create-report-use",
    component: CreateReportTaxDeductUse,
  },
  { path: "/tax-deduct/list-report-use", component: ListReportTaxDeductUse },
  {
    path: "/tax-deduct/create-report-transfer",
    component: CreateReportTaxDeductTransfer,
  },
  {
    path: "/tax-deduct/list-report-transfer",
    component: ListReportTaxDeductTransfer,
  },
];

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
  { path: "/pages-404", component: Pages404 },
  { path: "/pages-500", component: Pages500 },
  { path: "/tra-cuu-hoa-don", component: Portal },
];

export { authProtectedRoutes, publicRoutes };
